var map = {
	"./discover-se-console.png": 1240,
	"./discover-se3-console.png": 1241,
	"./discover-se3-hd-console.png": 1242,
	"./discover-si-console.png": 1243
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1239;


//////////////////
// WEBPACK FOOTER
// ./src/components/developerApi/developerSdk/Compatibility/images ^\.\/.*$
// module id = 1239
// module chunks = 0